import { render, staticRenderFns } from "./AgreeTermsAndPolitics.vue?vue&type=template&id=35ff9996&scoped=true&"
import script from "./AgreeTermsAndPolitics.vue?vue&type=script&lang=js&"
export * from "./AgreeTermsAndPolitics.vue?vue&type=script&lang=js&"
import style0 from "./AgreeTermsAndPolitics.vue?vue&type=style&index=0&id=35ff9996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff9996",
  null
  
)

export default component.exports